import React from "react";
import { AppSettings } from "../../config/app-settings.js";
import axios from "axios";
import { Link } from 'react-router-dom';
import Preloader from "../../components/custom/preLoader.js";
import showErrorToast, {  showSuccessToast } from "../../components/toast/toast";

class ForgetPassword extends React.Component {
  static contextType = AppSettings;

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      redirect: false,
      loading: false,
      error: null,
    };
  }

  componentDidMount() {
    this.context.handleSetAppSidebarNone(true);
    this.context.handleSetAppHeaderNone(true);
    this.context.handleSetAppContentClass("p-0");
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });

    const email = event.target.emailAddress.value;

    // Validation
    if (!email.trim()) {
      showErrorToast("Email is required");
      this.setState({ loading: false });
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showErrorToast("Please enter a valid email address");
      this.setState({ loading: false });
      return;
    }

    try {
      let API_URL = "";
      if (process.env.REACT_APP_Environment === 'development')
        API_URL = process.env.REACT_APP_API_URL;
      else
        API_URL = process.env.REACT_APP_API_URL_Production;

      const response = await axios.post(API_URL + "api/User/forgot-password", {
        email: email
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 15000
      });

      if (response.status === 200) {
        const msg =
          response.data?.message ||
          "If this account exists, a password reset email has been queued.";
        showSuccessToast(msg);
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
      const errorMessage = error.code === "ECONNABORTED"
        ? "Request timed out. Please try again."
        : (error.response?.data?.message || "Password reset request failed. Please try again.");
      showErrorToast(errorMessage);
    }
  }

  render() {
    const { loading } = this.state;
    
    // Check if it's mobile/tablet view
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
    
    return (
      loading ? <Preloader /> :
      <div className="pondstat-forget-password-page" style={{
        minHeight: '100vh',
        display: 'flex',
        backgroundColor: isMobile ? '#ffffff' : '#f8f9fa',
        backgroundImage: isMobile ? 'none' : "url(/assets/img/NewPondStatDataEntryHomePage2.png)",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '0'
      }}>
        
        {/* Left side - Background with branding (Hidden on mobile) */}
        {!isMobile && (
          <div style={{
            flex: isTablet ? '0.6' : '1',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: isTablet ? '40px' : '60px'
          }}>
            {/* Overlay for better text readability */}
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.3)'
            }}></div>
            
            {/* Logo and Title - Centered */}
            <div style={{ 
              position: 'relative', 
              zIndex: 2, 
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <div style={{
                fontSize: isTablet ? '3.5rem' : '4.5rem',
                fontWeight: 'bold',
                color: 'white',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                <span style={{ color: '#333' }}>POND</span>
                <span style={{ color: '#4ECDC4' }}>STAT</span>
              </div>
              
              <div style={{
                fontSize: isTablet ? '2rem' : '2.5rem',
                color: 'white',
                fontWeight: '300',
                marginBottom: '10px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                Data Entry
              </div>
              <div style={{
                fontSize: isTablet ? '1.5rem' : '2rem',
                color: 'white',
                fontWeight: '300',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                and
              </div>
              <div style={{
                fontSize: isTablet ? '2rem' : '2.5rem',
                color: 'white',
                fontWeight: '300',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
                Data Reduction
              </div>
            </div>
          </div>
        )}

        {/* Right side - Form container */}
        <div style={{
          width: isMobile ? '100%' : isTablet ? '400px' : '450px',
          backgroundColor: 'transparent',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: isMobile ? 'center' : 'center',
          padding: isMobile ? '20px' : isTablet ? '30px' : '40px',
          position: 'relative',
          minHeight: isMobile ? '100vh' : 'auto'
        }}>



          {/* Combined Title and Form Container */}
          <div style={{
            backgroundColor: isMobile ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: isMobile ? '30px' : '40px',
            boxShadow: isMobile ? 'none' : '0 8px 25px rgba(0,0,0,0.15)',
            marginBottom: isMobile ? '20px' : '25px'
          }}>
            {/* Title Section */}
            <div style={{ 
              textAlign: 'center', 
              marginBottom: '30px' 
            }}>
              <h2 style={{ 
                color: '#333', 
                marginBottom: '12px',
                fontSize: isMobile ? '24px' : '28px',
                fontWeight: '700'
              }}>
                Forgot Password
              </h2>
              <p style={{ 
                color: '#666', 
                fontSize: isMobile ? '14px' : '16px',
                margin: '0',
                lineHeight: '1.5'
              }}>
                Enter your email to reset your password
              </p>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div style={{ marginBottom: '25px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '10px',
                  color: '#333',
                  fontSize: '15px',
                  fontWeight: '600'
                }}>
                  Email Address
                </label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email address"
                  id="emailAddress"
                  name="emailAddress"
                  required
                  style={{
                    width: '100%',
                    padding: isMobile ? '14px 16px' : '15px 18px',
                    border: '2px solid #e1e5e9',
                    borderRadius: '12px',
                    fontSize: '16px',
                    transition: 'all 0.3s ease',
                    outline: 'none',
                    backgroundColor: '#fff'
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#4ECDC4';
                    e.target.style.boxShadow = '0 0 0 3px rgba(78, 205, 196, 0.1)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e1e5e9';
                    e.target.style.boxShadow = 'none';
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: isMobile ? '16px' : '18px',
                  backgroundColor: loading ? '#ccc' : '#4ECDC4',
                  color: 'white',
                  border: 'none',
                  borderRadius: '12px',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  marginBottom: '25px',
                  boxShadow: '0 4px 15px rgba(78, 205, 196, 0.3)',
                  transform: 'translateY(0)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}
                onMouseOver={(e) => {
                  if (!loading) {
                    e.target.style.backgroundColor = '#45b7aa';
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(78, 205, 196, 0.4)';
                  }
                }}
                onMouseOut={(e) => {
                  if (!loading) {
                    e.target.style.backgroundColor = '#4ECDC4';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(78, 205, 196, 0.3)';
                  }
                }}
              >
                {loading ? (
                  <>
                    <div style={{
                      width: '18px',
                      height: '18px',
                      border: '2px solid #ffffff',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    Sending...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i>
                    Send Reset Link
                  </>
                )}
              </button>

              <div style={{ 
                textAlign: 'center', 
                marginBottom: '20px',
                color: '#666',
                fontSize: '14px'
              }}>
                Remember your password? <Link 
                  to="/user/login" 
                  style={{ 
                    color: '#4ECDC4', 
                    textDecoration: 'none',
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#45b7aa'}
                  onMouseOut={(e) => e.target.style.color = '#4ECDC4'}
                >
                  Back to Login
                </Link>
              </div>

              <div style={{ 
                textAlign: 'center', 
                marginBottom: '0',
                color: '#666',
                fontSize: '14px'
              }}>
                Don't have an account? <Link 
                  to="/user/register" 
                  style={{ 
                    color: '#4ECDC4', 
                    textDecoration: 'none',
                    fontWeight: '600',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#45b7aa'}
                  onMouseOut={(e) => e.target.style.color = '#4ECDC4'}
                >
                  Sign up here
                </Link>
              </div>
            </form>
          </div>

          {/* Copyright Footer */}
          <div style={{
            backgroundColor: isMobile ? '#ffffff' : 'rgba(255, 255, 255, 0.95)',
            borderRadius: '20px',
            padding: '18px',
            boxShadow: isMobile ? 'none' : '0 8px 25px rgba(0,0,0,0.15)',
            textAlign: 'center',
            marginTop: '20px'
          }}>
            <div style={{
              color: '#999',
              fontSize: '12px',
              fontWeight: '500'
            }}>
              &copy; PONDSTAT. All Rights Reserved
            </div>
          </div>

        </div>

        {/* CSS Animation for loading spinner */}
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
}

export default ForgetPassword;